/* tslint:disable */
/* eslint-disable */
/**
 * veilstream API
 * The API for veilstream a Postgres Proxy Service that\'s .data privacy focused.
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface Action
 */
export interface Action {
    /**
     * 
     * @type {ActionType}
     * @memberof Action
     */
    'action_type': ActionType;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    'column_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    'function_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Action
     */
    'replacement_text'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Action
     */
    'replacement_integer'?: number | null;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof Action
     */
    'replacement_jsonb'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {number}
     * @memberof Action
     */
    'min_length'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Action
     */
    'max_length'?: number | null;
}


/**
 * 
 * @export
 * @interface ActionResponse
 */
export interface ActionResponse {
    /**
     * 
     * @type {string}
     * @memberof ActionResponse
     */
    'action': string;
    /**
     * 
     * @type {string}
     * @memberof ActionResponse
     */
    'field'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionResponse
     */
    'value'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionResponse
     */
    'value_type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionResponse
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ActionResponse
     */
    'deleted_at'?: string | null;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const ActionType = {
    HideColumn: 'hide column',
    HideRow: 'hide row',
    RenameColumn: 'rename column',
    ReplaceString: 'replace string',
    ReplaceInteger: 'replace integer',
    ReplaceJsonb: 'replace jsonb',
    RandomFirstname: 'random firstname',
    RandomLastname: 'random lastname',
    RandomName: 'random name',
    RandomEmail: 'random email',
    RandomPhone: 'random phone',
    RandomCountry: 'random country',
    RandomAdministrativeArea: 'random administrative area',
    RandomPostalCode: 'random postal code',
    RandomCity: 'random city',
    RandomStreetAddress: 'random street address',
    RandomAddress: 'random address',
    RandomTextLoremIpsum: 'random text lorem ipsum',
    RandomTextPicardIpsum: 'random text picard ipsum',
    RandomIpv4Address: 'random ipv4 address',
    RandomIpv6Address: 'random ipv6 address',
    RandomBoolean: 'random boolean',
    RandomLanguageName: 'random language name',
    RandomLanguageCode: 'random language code',
    RandomDate: 'random date'
} as const;

export type ActionType = typeof ActionType[keyof typeof ActionType];


/**
 * 
 * @export
 * @interface AdminOrganizationsResponse
 */
export interface AdminOrganizationsResponse {
    /**
     * 
     * @type {Array<OrganizationResponse>}
     * @memberof AdminOrganizationsResponse
     */
    'organizations': Array<OrganizationResponse>;
}
/**
 * 
 * @export
 * @interface AdminSubscriptionsResponse
 */
export interface AdminSubscriptionsResponse {
    /**
     * 
     * @type {Array<SubscriptionResponse>}
     * @memberof AdminSubscriptionsResponse
     */
    'subscriptions': Array<SubscriptionResponse>;
}
/**
 * 
 * @export
 * @interface ApiKeyResponse
 */
export interface ApiKeyResponse {
    /**
     * 
     * @type {string}
     * @memberof ApiKeyResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyResponse
     */
    'unencrypted_key'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyResponse
     */
    'key_prefix': string;
    /**
     * 
     * @type {string}
     * @memberof ApiKeyResponse
     */
    'key_postfix': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const BillingPlan = {
    Hobby: 'hobby',
    Startup: 'startup',
    Growth: 'growth',
    Enterprise: 'enterprise'
} as const;

export type BillingPlan = typeof BillingPlan[keyof typeof BillingPlan];


/**
 * 
 * @export
 * @interface ChangePlanRequest
 */
export interface ChangePlanRequest {
    /**
     * 
     * @type {BillingPlan}
     * @memberof ChangePlanRequest
     */
    'plan': BillingPlan;
}


/**
 * 
 * @export
 * @interface Client
 */
export interface Client {
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof Client
     */
    'username'?: string | null;
    /**
     * 
     * @type {Password}
     * @memberof Client
     */
    'password'?: Password | null;
    /**
     * 
     * @type {boolean}
     * @memberof Client
     */
    'enable_allowed_schemas'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof Client
     */
    'allowed_schemas'?: Array<string>;
    /**
     * 
     * @type {ClientMode}
     * @memberof Client
     */
    'mode'?: ClientMode;
    /**
     * 
     * @type {Array<Filter>}
     * @memberof Client
     */
    'filters': Array<Filter>;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ClientMode = {
    Readonly: 'readonly',
    Readwrite: 'readwrite'
} as const;

export type ClientMode = typeof ClientMode[keyof typeof ClientMode];


/**
 * 
 * @export
 * @interface Column
 */
export interface Column {
    /**
     * 
     * @type {string}
     * @memberof Column
     */
    'table_catalog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Column
     */
    'table_schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Column
     */
    'table_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Column
     */
    'column_name'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Column
     */
    'ordinal_position'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Column
     */
    'column_default'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Column
     */
    'is_nullable'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Column
     */
    'data_type'?: string | null;
    /**
     * 
     * @type {number}
     * @memberof Column
     */
    'character_maximum_length'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Column
     */
    'character_octet_length'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Column
     */
    'numeric_precision'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Column
     */
    'numeric_precision_radix'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Column
     */
    'numeric_scale'?: number | null;
    /**
     * 
     * @type {number}
     * @memberof Column
     */
    'datetime_precision'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof Column
     */
    'character_set_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof Column
     */
    'collation_name'?: string | null;
}
/**
 * 
 * @export
 * @interface Condition
 */
export interface Condition {
    /**
     * 
     * @type {string}
     * @memberof Condition
     */
    'column_name': string;
    /**
     * 
     * @type {OperatorType}
     * @memberof Condition
     */
    'operator': OperatorType;
    /**
     * 
     * @type {string}
     * @memberof Condition
     */
    'value': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof Condition
     */
    'values'?: Array<string>;
}


/**
 * 
 * @export
 * @interface ConditionResponse
 */
export interface ConditionResponse {
    /**
     * 
     * @type {string}
     * @memberof ConditionResponse
     */
    'field': string;
    /**
     * 
     * @type {string}
     * @memberof ConditionResponse
     */
    'operator': string;
    /**
     * 
     * @type {string}
     * @memberof ConditionResponse
     */
    'value'?: string;
    /**
     * 
     * @type {string}
     * @memberof ConditionResponse
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ConditionResponse
     */
    'deleted_at'?: string | null;
}
/**
 * 
 * @export
 * @interface ContainerDefinition
 */
export interface ContainerDefinition {
    /**
     * 
     * @type {string}
     * @memberof ContainerDefinition
     */
    'proxy_id': string;
    /**
     * 
     * @type {string}
     * @memberof ContainerDefinition
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof ContainerDefinition
     */
    'image': string;
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ContainerDefinition
     */
    'environment': { [key: string]: string; };
    /**
     * 
     * @type {{ [key: string]: string; }}
     * @memberof ContainerDefinition
     */
    'labels': { [key: string]: string; };
}
/**
 * 
 * @export
 * @interface CreateHostedProxyRequest
 */
export interface CreateHostedProxyRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateHostedProxyRequest
     */
    'server_id': string;
    /**
     * 
     * @type {string}
     * @memberof CreateHostedProxyRequest
     */
    'db_username': string;
    /**
     * 
     * @type {string}
     * @memberof CreateHostedProxyRequest
     */
    'db_password': string;
    /**
     * 
     * @type {string}
     * @memberof CreateHostedProxyRequest
     */
    'db_host': string;
    /**
     * 
     * @type {number}
     * @memberof CreateHostedProxyRequest
     */
    'db_port': number;
    /**
     * 
     * @type {string}
     * @memberof CreateHostedProxyRequest
     */
    'db_database_name': string;
}
/**
 * 
 * @export
 * @interface Database
 */
export interface Database {
    /**
     * 
     * @type {string}
     * @memberof Database
     */
    'uri_env': string;
}
/**
 * 
 * @export
 * @interface DatabaseConnection
 */
export interface DatabaseConnection {
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnection
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnection
     */
    'password': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnection
     */
    'host': string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseConnection
     */
    'port'?: number | null;
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnection
     */
    'database_name': string;
}
/**
 * 
 * @export
 * @interface DatabaseConnectionResponse
 */
export interface DatabaseConnectionResponse {
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnectionResponse
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnectionResponse
     */
    'host': string;
    /**
     * 
     * @type {number}
     * @memberof DatabaseConnectionResponse
     */
    'port': number;
    /**
     * 
     * @type {string}
     * @memberof DatabaseConnectionResponse
     */
    'database_name': string;
}
/**
 * 
 * @export
 * @interface DatabaseResponse
 */
export interface DatabaseResponse {
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponse
     */
    'uid': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof DatabaseResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {Array<TableResponse>}
     * @memberof DatabaseResponse
     */
    'tables': Array<TableResponse>;
}
/**
 * 
 * @export
 * @interface DockerImage
 */
export interface DockerImage {
    /**
     * 
     * @type {string}
     * @memberof DockerImage
     */
    'username': string;
    /**
     * 
     * @type {string}
     * @memberof DockerImage
     */
    'image_name': string;
    /**
     * 
     * @type {string}
     * @memberof DockerImage
     */
    'label': string;
    /**
     * 
     * @type {string}
     * @memberof DockerImage
     */
    'full_image_name': string;
    /**
     * 
     * @type {number}
     * @memberof DockerImage
     */
    'size': number;
}
/**
 * 
 * @export
 * @interface EmailRequest
 */
export interface EmailRequest {
    /**
     * 
     * @type {string}
     * @memberof EmailRequest
     */
    'email_id'?: string;
    /**
     * 
     * @type {string}
     * @memberof EmailRequest
     */
    'recipient': string;
    /**
     * 
     * @type {string}
     * @memberof EmailRequest
     */
    'esp_account'?: string;
}
/**
 * 
 * @export
 * @interface Filter
 */
export interface Filter {
    /**
     * 
     * @type {string}
     * @memberof Filter
     */
    'table_name': string | null;
    /**
     * 
     * @type {Array<Action>}
     * @memberof Filter
     */
    'actions': Array<Action>;
    /**
     * 
     * @type {Array<Condition>}
     * @memberof Filter
     */
    'conditions': Array<Condition>;
}
/**
 * 
 * @export
 * @interface FilterRequest
 */
export interface FilterRequest {
    /**
     * 
     * @type {string}
     * @memberof FilterRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FilterRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterRequest
     */
    'server': string;
    /**
     * 
     * @type {string}
     * @memberof FilterRequest
     */
    'schema': string;
    /**
     * 
     * @type {string}
     * @memberof FilterRequest
     */
    'table': string;
    /**
     * 
     * @type {Array<ConditionResponse>}
     * @memberof FilterRequest
     */
    'conditions': Array<ConditionResponse>;
    /**
     * 
     * @type {Array<ActionResponse>}
     * @memberof FilterRequest
     */
    'actions': Array<ActionResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof FilterRequest
     */
    'role_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface FilterResponse
 */
export interface FilterResponse {
    /**
     * 
     * @type {string}
     * @memberof FilterResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof FilterResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof FilterResponse
     */
    'description': string | null;
    /**
     * 
     * @type {Array<ConditionResponse>}
     * @memberof FilterResponse
     */
    'conditions': Array<ConditionResponse>;
    /**
     * 
     * @type {Array<ActionResponse>}
     * @memberof FilterResponse
     */
    'actions': Array<ActionResponse>;
    /**
     * 
     * @type {Array<RoleResponse>}
     * @memberof FilterResponse
     */
    'roles': Array<RoleResponse>;
    /**
     * 
     * @type {ServerResponse}
     * @memberof FilterResponse
     */
    'server'?: ServerResponse | null;
    /**
     * 
     * @type {string}
     * @memberof FilterResponse
     */
    'schema'?: string | null;
    /**
     * 
     * @type {TableResponse}
     * @memberof FilterResponse
     */
    'table'?: TableResponse | null;
    /**
     * 
     * @type {string}
     * @memberof FilterResponse
     */
    'created_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof FilterResponse
     */
    'deleted_at'?: string | null;
}
/**
 * 
 * @export
 * @interface HTTPValidationError
 */
export interface HTTPValidationError {
    /**
     * 
     * @type {Array<ValidationError>}
     * @memberof HTTPValidationError
     */
    'detail'?: Array<ValidationError>;
}
/**
 * 
 * @export
 * @interface HostedProxyResponse
 */
export interface HostedProxyResponse {
    /**
     * 
     * @type {string}
     * @memberof HostedProxyResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof HostedProxyResponse
     */
    'server_id': string;
    /**
     * 
     * @type {string}
     * @memberof HostedProxyResponse
     */
    'db_username': string;
    /**
     * 
     * @type {string}
     * @memberof HostedProxyResponse
     */
    'db_host': string;
    /**
     * 
     * @type {number}
     * @memberof HostedProxyResponse
     */
    'db_port': number;
    /**
     * 
     * @type {string}
     * @memberof HostedProxyResponse
     */
    'db_database_name': string;
    /**
     * 
     * @type {HostedProxyStatus}
     * @memberof HostedProxyResponse
     */
    'status': HostedProxyStatus;
    /**
     * 
     * @type {string}
     * @memberof HostedProxyResponse
     */
    'status_updated_at': string;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const HostedProxyStatus = {
    Unknown: 'unknown',
    Booting: 'booting',
    Running: 'running',
    Stopped: 'stopped'
} as const;

export type HostedProxyStatus = typeof HostedProxyStatus[keyof typeof HostedProxyStatus];


/**
 * 
 * @export
 * @enum {string}
 */

export const HostingMode = {
    SelfHosted: 'self-hosted',
    Cloud: 'cloud'
} as const;

export type HostingMode = typeof HostingMode[keyof typeof HostingMode];


/**
 * 
 * @export
 * @enum {string}
 */

export const LogLevel = {
    LoglevelDebug: 'LOGLEVEL DEBUG',
    LoglevelInfo: 'LOGLEVEL INFO',
    LoglevelWarning: 'LOGLEVEL WARNING',
    LoglevelError: 'LOGLEVEL ERROR',
    LoglevelCritical: 'LOGLEVEL CRITICAL'
} as const;

export type LogLevel = typeof LogLevel[keyof typeof LogLevel];


/**
 * 
 * @export
 * @interface LoginRequest
 */
export interface LoginRequest {
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'credential': string;
    /**
     * 
     * @type {string}
     * @memberof LoginRequest
     */
    'clientId': string;
}
/**
 * 
 * @export
 * @enum {string}
 */

export const OperatorType = {
    Equals: 'equals',
    NotEquals: 'not equals',
    Like: 'like',
    Contains: 'contains',
    NotContains: 'not contains',
    GreaterThan: 'greater than',
    LessThan: 'less than',
    GreaterThanOrEquals: 'greater than or equals',
    LessThanOrEquals: 'less than or equals',
    In: 'in'
} as const;

export type OperatorType = typeof OperatorType[keyof typeof OperatorType];


/**
 * 
 * @export
 * @interface OrganizationRequest
 */
export interface OrganizationRequest {
    /**
     * 
     * @type {string}
     * @memberof OrganizationRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationRequest
     */
    'description'?: string | null;
}
/**
 * 
 * @export
 * @interface OrganizationResponse
 */
export interface OrganizationResponse {
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof OrganizationResponse
     */
    'name': string;
    /**
     * 
     * @type {Array<DatabaseResponse>}
     * @memberof OrganizationResponse
     */
    'databases': Array<DatabaseResponse>;
    /**
     * 
     * @type {Array<UserResponse>}
     * @memberof OrganizationResponse
     */
    'users': Array<UserResponse>;
    /**
     * 
     * @type {number}
     * @memberof OrganizationResponse
     */
    'created_at': number;
}
/**
 * 
 * @export
 * @interface PaddleItem
 */
export interface PaddleItem {
    /**
     * 
     * @type {string}
     * @memberof PaddleItem
     */
    'product_name': string;
    /**
     * 
     * @type {string}
     * @memberof PaddleItem
     */
    'price_name': string;
    /**
     * 
     * @type {number}
     * @memberof PaddleItem
     */
    'unit_price_amount': number;
    /**
     * 
     * @type {string}
     * @memberof PaddleItem
     */
    'unit_price_currency': string;
}
/**
 * 
 * @export
 * @interface Password
 */
export interface Password {
    /**
     * 
     * @type {string}
     * @memberof Password
     */
    'salt': string;
    /**
     * 
     * @type {number}
     * @memberof Password
     */
    'iterations': number;
    /**
     * 
     * @type {string}
     * @memberof Password
     */
    'server_key': string;
    /**
     * 
     * @type {string}
     * @memberof Password
     */
    'stored_key': string;
}
/**
 * 
 * @export
 * @interface ProxyConfigurationLastUpdatedAtResponse
 */
export interface ProxyConfigurationLastUpdatedAtResponse {
    /**
     * 
     * @type {number}
     * @memberof ProxyConfigurationLastUpdatedAtResponse
     */
    'last_updated_at_seconds': number;
}
/**
 * 
 * @export
 * @interface ProxyConfigurationResponse
 */
export interface ProxyConfigurationResponse {
    /**
     * 
     * @type {LogLevel}
     * @memberof ProxyConfigurationResponse
     */
    'log_level': LogLevel;
    /**
     * 
     * @type {Database}
     * @memberof ProxyConfigurationResponse
     */
    'database': Database;
    /**
     * 
     * @type {Array<Client>}
     * @memberof ProxyConfigurationResponse
     */
    'clients': Array<Client>;
}


/**
 * 
 * @export
 * @interface ProxyEventRequest
 */
export interface ProxyEventRequest {
    /**
     * 
     * @type {ProxyEventType}
     * @memberof ProxyEventRequest
     */
    'event_type': ProxyEventType;
    /**
     * 
     * @type {string}
     * @memberof ProxyEventRequest
     */
    'message': string;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ProxyEventRequest
     */
    'data'?: { [key: string]: any; } | null;
    /**
     * 
     * @type {string}
     * @memberof ProxyEventRequest
     */
    'at'?: string | null;
}


/**
 * 
 * @export
 * @enum {string}
 */

export const ProxyEventType = {
    ProxyEventBooting: 'proxy event: booting',
    ProxyEventError: 'proxy event: error',
    ProxyEventConnectingToDb: 'proxy event: connecting to db',
    ProxyEventConnectingToDbSuccess: 'proxy event: connecting to db success',
    ProxyEventInsertingStoredProcedures: 'proxy event: inserting stored procedures',
    ProxyEventInsertingStoredProceduresSuccess: 'proxy event: inserting stored procedures success',
    ProxyEventLogin: 'proxy event: login',
    ProxyEventConnectionClosed: 'proxy event: connection closed',
    ProxyEventAuthenticationSuccess: 'proxy event: authentication success',
    ProxyEventAuthenticationFailure: 'proxy event: authentication failure',
    ProxyEventGetConfiguration: 'proxy event: get configuration',
    ProxyEventGetConfigurationSuccess: 'proxy event: get configuration success',
    ProxyEventQuery: 'proxy event: query',
    ProxyEventQuerySuccess: 'proxy event: query success',
    ProxyEventQueryFailure: 'proxy event: query failure'
} as const;

export type ProxyEventType = typeof ProxyEventType[keyof typeof ProxyEventType];


/**
 * 
 * @export
 * @interface ProxyEventsBatchRequest
 */
export interface ProxyEventsBatchRequest {
    /**
     * 
     * @type {Array<ProxyEventRequest>}
     * @memberof ProxyEventsBatchRequest
     */
    'events': Array<ProxyEventRequest>;
}
/**
 * 
 * @export
 * @interface RoleCreateRequest
 */
export interface RoleCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof RoleCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RoleCreateRequest
     */
    'description': string;
}
/**
 * 
 * @export
 * @interface RoleResponse
 */
export interface RoleResponse {
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    'description': string;
    /**
     * 
     * @type {string}
     * @memberof RoleResponse
     */
    'id': string;
    /**
     * 
     * @type {number}
     * @memberof RoleResponse
     */
    'num_users': number;
}
/**
 * 
 * @export
 * @interface ServerCreateRequest
 */
export interface ServerCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof ServerCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof ServerCreateRequest
     */
    'description'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerCreateRequest
     */
    'on_schema_change'?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerCreateRequest
     */
    'schema_allow_list'?: Array<string> | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerCreateRequest
     */
    'role_ids': Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ServerCreateRequest
     */
    'hosting_mode': string;
    /**
     * 
     * @type {DatabaseConnection}
     * @memberof ServerCreateRequest
     */
    'database_connection'?: DatabaseConnection | null;
}
/**
 * 
 * @export
 * @interface ServerResponse
 */
export interface ServerResponse {
    /**
     * 
     * @type {string}
     * @memberof ServerResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof ServerResponse
     */
    'name': string;
    /**
     * 
     * @type {boolean}
     * @memberof ServerResponse
     */
    'is_active'?: boolean;
    /**
     * 
     * @type {string}
     * @memberof ServerResponse
     */
    'description'?: string | null;
    /**
     * 
     * @type {HostingMode}
     * @memberof ServerResponse
     */
    'hosting_mode': HostingMode;
    /**
     * 
     * @type {DatabaseConnectionResponse}
     * @memberof ServerResponse
     */
    'database_connection'?: DatabaseConnectionResponse | null;
    /**
     * 
     * @type {Array<ApiKeyResponse>}
     * @memberof ServerResponse
     */
    'api_keys': Array<ApiKeyResponse>;
    /**
     * 
     * @type {number}
     * @memberof ServerResponse
     */
    'api_keys_count'?: number;
    /**
     * 
     * @type {Array<TableResponse>}
     * @memberof ServerResponse
     */
    'tables': Array<TableResponse>;
    /**
     * 
     * @type {number}
     * @memberof ServerResponse
     */
    'tables_count'?: number;
    /**
     * 
     * @type {Array<FilterResponse>}
     * @memberof ServerResponse
     */
    'filters': Array<FilterResponse>;
    /**
     * 
     * @type {number}
     * @memberof ServerResponse
     */
    'filters_count'?: number;
    /**
     * 
     * @type {string}
     * @memberof ServerResponse
     */
    'on_schema_change'?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof ServerResponse
     */
    'allowed_schemas_enabled'?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerResponse
     */
    'allowed_schemas'?: Array<string> | null;
    /**
     * 
     * @type {Array<RoleResponse>}
     * @memberof ServerResponse
     */
    'roles': Array<RoleResponse>;
    /**
     * 
     * @type {Array<string>}
     * @memberof ServerResponse
     */
    'usernames'?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof ServerResponse
     */
    'status'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerResponse
     */
    'status_reason'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerResponse
     */
    'status_updated_at'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof ServerResponse
     */
    'updated_at'?: string | null;
}


/**
 * 
 * @export
 * @interface SetProxyStatusRequest
 */
export interface SetProxyStatusRequest {
    /**
     * 
     * @type {HostedProxyStatus}
     * @memberof SetProxyStatusRequest
     */
    'status': HostedProxyStatus;
}


/**
 * 
 * @export
 * @interface SubscriptionResponse
 */
export interface SubscriptionResponse {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'paddle_subscription_id': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'status': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'user_id': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'customer_paddle_id': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'customer_paddle_url': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'created_at': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'updated_at': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'first_billed_at': string;
    /**
     * 
     * @type {string}
     * @memberof SubscriptionResponse
     */
    'next_billed_at': string | null;
    /**
     * 
     * @type {Array<PaddleItem>}
     * @memberof SubscriptionResponse
     */
    'items': Array<PaddleItem>;
}
/**
 * 
 * @export
 * @interface SyntheticUserCreateRequest
 */
export interface SyntheticUserCreateRequest {
    /**
     * 
     * @type {string}
     * @memberof SyntheticUserCreateRequest
     */
    'name': string;
    /**
     * 
     * @type {string}
     * @memberof SyntheticUserCreateRequest
     */
    'password': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyntheticUserCreateRequest
     */
    'role_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface SyntheticUserResponse
 */
export interface SyntheticUserResponse {
    /**
     * 
     * @type {string}
     * @memberof SyntheticUserResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof SyntheticUserResponse
     */
    'name': string;
    /**
     * 
     * @type {Array<RoleResponse>}
     * @memberof SyntheticUserResponse
     */
    'roles': Array<RoleResponse>;
}
/**
 * 
 * @export
 * @interface SyntheticUserUpdatePasswordRequest
 */
export interface SyntheticUserUpdatePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof SyntheticUserUpdatePasswordRequest
     */
    'password': string;
}
/**
 * 
 * @export
 * @interface SyntheticUserUpdateRequest
 */
export interface SyntheticUserUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof SyntheticUserUpdateRequest
     */
    'name': string;
    /**
     * 
     * @type {Array<string>}
     * @memberof SyntheticUserUpdateRequest
     */
    'role_ids': Array<string>;
}
/**
 * 
 * @export
 * @interface TableResponse
 */
export interface TableResponse {
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'catalog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'table_schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'type'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'self_referencing_column_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'reference_generation'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'user_defined_type_catalog'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'user_defined_type_schema'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'user_defined_type_name'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'is_insertable_into'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'is_typed'?: string | null;
    /**
     * 
     * @type {string}
     * @memberof TableResponse
     */
    'commit_action'?: string | null;
    /**
     * 
     * @type {Array<Column>}
     * @memberof TableResponse
     */
    'columns': Array<Column> | null;
}
/**
 * 
 * @export
 * @interface UpdateHostedProxyRequest
 */
export interface UpdateHostedProxyRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdateHostedProxyRequest
     */
    'enabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateHostedProxyRequest
     */
    'db_username': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateHostedProxyRequest
     */
    'db_password': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateHostedProxyRequest
     */
    'db_host': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateHostedProxyRequest
     */
    'db_port': number;
    /**
     * 
     * @type {string}
     * @memberof UpdateHostedProxyRequest
     */
    'db_database_name': string;
}
/**
 * 
 * @export
 * @interface UserRequest
 */
export interface UserRequest {
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserRequest
     */
    'permission_level'?: string;
}
/**
 * 
 * @export
 * @interface UserResponse
 */
export interface UserResponse {
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'id': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'email': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'organization_id': string;
    /**
     * 
     * @type {string}
     * @memberof UserResponse
     */
    'permission_level': string;
    /**
     * 
     * @type {number}
     * @memberof UserResponse
     */
    'created_at': number;
}
/**
 * 
 * @export
 * @interface UsernamesRequest
 */
export interface UsernamesRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof UsernamesRequest
     */
    'usernames'?: Array<string> | null;
}
/**
 * 
 * @export
 * @interface ValidationError
 */
export interface ValidationError {
    /**
     * 
     * @type {Array<ValidationErrorLocInner>}
     * @memberof ValidationError
     */
    'loc': Array<ValidationErrorLocInner>;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'msg': string;
    /**
     * 
     * @type {string}
     * @memberof ValidationError
     */
    'type': string;
}
/**
 * 
 * @export
 * @interface ValidationErrorLocInner
 */
export interface ValidationErrorLocInner {
}

/**
 * AdminApi - axios parameter creator
 * @export
 */
export const AdminApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Organization Billing
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationBillingOrganizationsBillingGet: async (jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations/billing`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Organizations
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationsOrganizationsGet: async (jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AdminApi - functional programming interface
 * @export
 */
export const AdminApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AdminApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Organization Billing
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationBillingOrganizationsBillingGet(jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminSubscriptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationBillingOrganizationsBillingGet(jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.getOrganizationBillingOrganizationsBillingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Organizations
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listOrganizationsOrganizationsGet(jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AdminOrganizationsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listOrganizationsOrganizationsGet(jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AdminApi.listOrganizationsOrganizationsGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AdminApi - factory interface
 * @export
 */
export const AdminApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AdminApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Organization Billing
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationBillingOrganizationsBillingGet(jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminSubscriptionsResponse> {
            return localVarFp.getOrganizationBillingOrganizationsBillingGet(jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Organizations
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listOrganizationsOrganizationsGet(jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<AdminOrganizationsResponse> {
            return localVarFp.listOrganizationsOrganizationsGet(jwtToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AdminApi - object-oriented interface
 * @export
 * @class AdminApi
 * @extends {BaseAPI}
 */
export class AdminApi extends BaseAPI {
    /**
     * 
     * @summary Get Organization Billing
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public getOrganizationBillingOrganizationsBillingGet(jwtToken?: string, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).getOrganizationBillingOrganizationsBillingGet(jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Organizations
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AdminApi
     */
    public listOrganizationsOrganizationsGet(jwtToken?: string, options?: RawAxiosRequestConfig) {
        return AdminApiFp(this.configuration).listOrganizationsOrganizationsGet(jwtToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InternalServicesApi - axios parameter creator
 * @export
 */
export const InternalServicesApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Container Definition
         * @param {string} proxyId 
         * @param {string} xProxyApiVersion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerDefinitionInternalProxyProxyIdContainerDefinitionGet: async (proxyId: string, xProxyApiVersion: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('getContainerDefinitionInternalProxyProxyIdContainerDefinitionGet', 'proxyId', proxyId)
            // verify required parameter 'xProxyApiVersion' is not null or undefined
            assertParamExists('getContainerDefinitionInternalProxyProxyIdContainerDefinitionGet', 'xProxyApiVersion', xProxyApiVersion)
            const localVarPath = `/internal/proxy/{proxy_id}/container_definition`
                .replace(`{${"proxy_id"}}`, encodeURIComponent(String(proxyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            if (xProxyApiVersion != null) {
                localVarHeaderParameter['x-proxy-api-version'] = String(xProxyApiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Hosted Proxy By Id
         * @param {string} proxyId 
         * @param {string} xProxyApiVersion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHostedProxyByIdInternalProxyProxyIdGet: async (proxyId: string, xProxyApiVersion: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('getHostedProxyByIdInternalProxyProxyIdGet', 'proxyId', proxyId)
            // verify required parameter 'xProxyApiVersion' is not null or undefined
            assertParamExists('getHostedProxyByIdInternalProxyProxyIdGet', 'xProxyApiVersion', xProxyApiVersion)
            const localVarPath = `/internal/proxy/{proxy_id}`
                .replace(`{${"proxy_id"}}`, encodeURIComponent(String(proxyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            if (xProxyApiVersion != null) {
                localVarHeaderParameter['x-proxy-api-version'] = String(xProxyApiVersion);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Set Proxy Status
         * @param {string} proxyId 
         * @param {SetProxyStatusRequest} setProxyStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProxyStatusInternalProxyProxyIdStatusPost: async (proxyId: string, setProxyStatusRequest: SetProxyStatusRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proxyId' is not null or undefined
            assertParamExists('setProxyStatusInternalProxyProxyIdStatusPost', 'proxyId', proxyId)
            // verify required parameter 'setProxyStatusRequest' is not null or undefined
            assertParamExists('setProxyStatusInternalProxyProxyIdStatusPost', 'setProxyStatusRequest', setProxyStatusRequest)
            const localVarPath = `/internal/proxy/{proxy_id}/status`
                .replace(`{${"proxy_id"}}`, encodeURIComponent(String(proxyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(setProxyStatusRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InternalServicesApi - functional programming interface
 * @export
 */
export const InternalServicesApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InternalServicesApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Container Definition
         * @param {string} proxyId 
         * @param {string} xProxyApiVersion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getContainerDefinitionInternalProxyProxyIdContainerDefinitionGet(proxyId: string, xProxyApiVersion: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerDefinition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getContainerDefinitionInternalProxyProxyIdContainerDefinitionGet(proxyId, xProxyApiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalServicesApi.getContainerDefinitionInternalProxyProxyIdContainerDefinitionGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Hosted Proxy By Id
         * @param {string} proxyId 
         * @param {string} xProxyApiVersion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHostedProxyByIdInternalProxyProxyIdGet(proxyId: string, xProxyApiVersion: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ContainerDefinition>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHostedProxyByIdInternalProxyProxyIdGet(proxyId, xProxyApiVersion, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalServicesApi.getHostedProxyByIdInternalProxyProxyIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Set Proxy Status
         * @param {string} proxyId 
         * @param {SetProxyStatusRequest} setProxyStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async setProxyStatusInternalProxyProxyIdStatusPost(proxyId: string, setProxyStatusRequest: SetProxyStatusRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.setProxyStatusInternalProxyProxyIdStatusPost(proxyId, setProxyStatusRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InternalServicesApi.setProxyStatusInternalProxyProxyIdStatusPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InternalServicesApi - factory interface
 * @export
 */
export const InternalServicesApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InternalServicesApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Container Definition
         * @param {string} proxyId 
         * @param {string} xProxyApiVersion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getContainerDefinitionInternalProxyProxyIdContainerDefinitionGet(proxyId: string, xProxyApiVersion: string, options?: RawAxiosRequestConfig): AxiosPromise<ContainerDefinition> {
            return localVarFp.getContainerDefinitionInternalProxyProxyIdContainerDefinitionGet(proxyId, xProxyApiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Hosted Proxy By Id
         * @param {string} proxyId 
         * @param {string} xProxyApiVersion 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHostedProxyByIdInternalProxyProxyIdGet(proxyId: string, xProxyApiVersion: string, options?: RawAxiosRequestConfig): AxiosPromise<ContainerDefinition> {
            return localVarFp.getHostedProxyByIdInternalProxyProxyIdGet(proxyId, xProxyApiVersion, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Set Proxy Status
         * @param {string} proxyId 
         * @param {SetProxyStatusRequest} setProxyStatusRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        setProxyStatusInternalProxyProxyIdStatusPost(proxyId: string, setProxyStatusRequest: SetProxyStatusRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.setProxyStatusInternalProxyProxyIdStatusPost(proxyId, setProxyStatusRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InternalServicesApi - object-oriented interface
 * @export
 * @class InternalServicesApi
 * @extends {BaseAPI}
 */
export class InternalServicesApi extends BaseAPI {
    /**
     * 
     * @summary Get Container Definition
     * @param {string} proxyId 
     * @param {string} xProxyApiVersion 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalServicesApi
     */
    public getContainerDefinitionInternalProxyProxyIdContainerDefinitionGet(proxyId: string, xProxyApiVersion: string, options?: RawAxiosRequestConfig) {
        return InternalServicesApiFp(this.configuration).getContainerDefinitionInternalProxyProxyIdContainerDefinitionGet(proxyId, xProxyApiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Hosted Proxy By Id
     * @param {string} proxyId 
     * @param {string} xProxyApiVersion 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalServicesApi
     */
    public getHostedProxyByIdInternalProxyProxyIdGet(proxyId: string, xProxyApiVersion: string, options?: RawAxiosRequestConfig) {
        return InternalServicesApiFp(this.configuration).getHostedProxyByIdInternalProxyProxyIdGet(proxyId, xProxyApiVersion, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Set Proxy Status
     * @param {string} proxyId 
     * @param {SetProxyStatusRequest} setProxyStatusRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalServicesApi
     */
    public setProxyStatusInternalProxyProxyIdStatusPost(proxyId: string, setProxyStatusRequest: SetProxyStatusRequest, options?: RawAxiosRequestConfig) {
        return InternalServicesApiFp(this.configuration).setProxyStatusInternalProxyProxyIdStatusPost(proxyId, setProxyStatusRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProtectedApi - axios parameter creator
 * @export
 */
export const ProtectedApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Accept Toc
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTocAcceptTocPost: async (jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/accept/toc`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change Owner
         * @param {string} userId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOwnerUserUserIdChangeOwnerPost: async (userId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('changeOwnerUserUserIdChangeOwnerPost', 'userId', userId)
            const localVarPath = `/user/{user_id}/change_owner`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Change Pan
         * @param {ChangePlanRequest} changePlanRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePanBillingPlanChangePost: async (changePlanRequest: ChangePlanRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'changePlanRequest' is not null or undefined
            assertParamExists('changePanBillingPlanChangePost', 'changePlanRequest', changePlanRequest)
            const localVarPath = `/billing/plan/change`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(changePlanRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Api Key
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeyServerServerIdApiKeyPost: async (serverId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverId' is not null or undefined
            assertParamExists('createApiKeyServerServerIdApiKeyPost', 'serverId', serverId)
            const localVarPath = `/server/{server_id}/api_key`
                .replace(`{${"server_id"}}`, encodeURIComponent(String(serverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Filter
         * @param {FilterRequest} filterRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilterFilterPost: async (filterRequest: FilterRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterRequest' is not null or undefined
            assertParamExists('createFilterFilterPost', 'filterRequest', filterRequest)
            const localVarPath = `/filter`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Hosted Proxy
         * @param {CreateHostedProxyRequest} createHostedProxyRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHostedProxyHostedProxyPost: async (createHostedProxyRequest: CreateHostedProxyRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createHostedProxyRequest' is not null or undefined
            assertParamExists('createHostedProxyHostedProxyPost', 'createHostedProxyRequest', createHostedProxyRequest)
            const localVarPath = `/hosted_proxy`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHostedProxyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Org
         * @param {OrganizationRequest} organizationRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgOrganizationsPost: async (organizationRequest: OrganizationRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationRequest' is not null or undefined
            assertParamExists('createOrgOrganizationsPost', 'organizationRequest', organizationRequest)
            const localVarPath = `/organizations`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(organizationRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Role
         * @param {RoleCreateRequest} roleCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleRolePost: async (roleCreateRequest: RoleCreateRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleCreateRequest' is not null or undefined
            assertParamExists('createRoleRolePost', 'roleCreateRequest', roleCreateRequest)
            const localVarPath = `/role`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Server
         * @param {ServerCreateRequest} serverCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServerServerPost: async (serverCreateRequest: ServerCreateRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverCreateRequest' is not null or undefined
            assertParamExists('createServerServerPost', 'serverCreateRequest', serverCreateRequest)
            const localVarPath = `/server`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Synthetic User
         * @param {SyntheticUserCreateRequest} syntheticUserCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSyntheticUserSyntheticUserPost: async (syntheticUserCreateRequest: SyntheticUserCreateRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syntheticUserCreateRequest' is not null or undefined
            assertParamExists('createSyntheticUserSyntheticUserPost', 'syntheticUserCreateRequest', syntheticUserCreateRequest)
            const localVarPath = `/synthetic_user`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syntheticUserCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create User
         * @param {UserRequest} userRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserUsersPost: async (userRequest: UserRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userRequest' is not null or undefined
            assertParamExists('createUserUsersPost', 'userRequest', userRequest)
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Api Key
         * @param {string} serverId 
         * @param {string} apiKeyId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyServerServerIdApiKeyApiKeyIdDelete: async (serverId: string, apiKeyId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverId' is not null or undefined
            assertParamExists('deleteApiKeyServerServerIdApiKeyApiKeyIdDelete', 'serverId', serverId)
            // verify required parameter 'apiKeyId' is not null or undefined
            assertParamExists('deleteApiKeyServerServerIdApiKeyApiKeyIdDelete', 'apiKeyId', apiKeyId)
            const localVarPath = `/server/{server_id}/api_key/{api_key_id}`
                .replace(`{${"server_id"}}`, encodeURIComponent(String(serverId)))
                .replace(`{${"api_key_id"}}`, encodeURIComponent(String(apiKeyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Filter
         * @param {string} filterId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterFilterFilterIdDelete: async (filterId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterId' is not null or undefined
            assertParamExists('deleteFilterFilterFilterIdDelete', 'filterId', filterId)
            const localVarPath = `/filter/{filter_id}`
                .replace(`{${"filter_id"}}`, encodeURIComponent(String(filterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Hosted Proxy
         * @param {string} hostedProxyId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHostedProxyHostedProxyHostedProxyIdDelete: async (hostedProxyId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hostedProxyId' is not null or undefined
            assertParamExists('deleteHostedProxyHostedProxyHostedProxyIdDelete', 'hostedProxyId', hostedProxyId)
            const localVarPath = `/hosted_proxy/{hosted_proxy_id}`
                .replace(`{${"hosted_proxy_id"}}`, encodeURIComponent(String(hostedProxyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Org
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgOrganizationDelete: async (jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/organization`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Role
         * @param {string} roleId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleRoleRoleIdDelete: async (roleId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('deleteRoleRoleRoleIdDelete', 'roleId', roleId)
            const localVarPath = `/role/{role_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Server
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServerServerServerIdDelete: async (serverId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverId' is not null or undefined
            assertParamExists('deleteServerServerServerIdDelete', 'serverId', serverId)
            const localVarPath = `/server/{server_id}`
                .replace(`{${"server_id"}}`, encodeURIComponent(String(serverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete Synthetic User
         * @param {string} syntheticUserId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSyntheticUserSyntheticUserSyntheticUserIdDelete: async (syntheticUserId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syntheticUserId' is not null or undefined
            assertParamExists('deleteSyntheticUserSyntheticUserSyntheticUserIdDelete', 'syntheticUserId', syntheticUserId)
            const localVarPath = `/synthetic_user/{synthetic_user_id}`
                .replace(`{${"synthetic_user_id"}}`, encodeURIComponent(String(syntheticUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete User
         * @param {string} userId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserUserUserIdDelete: async (userId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('deleteUserUserUserIdDelete', 'userId', userId)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * :return: a filter by id
         * @summary Get Filter
         * @param {string} filterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterFilterFilterIdGet: async (filterId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterId' is not null or undefined
            assertParamExists('getFilterFilterFilterIdGet', 'filterId', filterId)
            const localVarPath = `/filter/{filter_id}`
                .replace(`{${"filter_id"}}`, encodeURIComponent(String(filterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * :return: a list of all filters for the organization
         * @summary Get Filters
         * @param {boolean} [archived] 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltersFiltersGet: async (archived?: boolean, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (archived !== undefined) {
                localVarQueryParameter['archived'] = archived;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Hosted Proxy
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHostedProxyHostedProxyServerIdGet: async (serverId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverId' is not null or undefined
            assertParamExists('getHostedProxyHostedProxyServerIdGet', 'serverId', serverId)
            const localVarPath = `/hosted_proxy/{server_id}`
                .replace(`{${"server_id"}}`, encodeURIComponent(String(serverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Org
         * @param {string} organizationId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgOrganizationsOrganizationIdGet: async (organizationId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrgOrganizationsOrganizationIdGet', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organization_id}`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Organization Billing
         * @param {string} organizationId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationBillingOrganizationsOrganizationIdBillingGet: async (organizationId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'organizationId' is not null or undefined
            assertParamExists('getOrganizationBillingOrganizationsOrganizationIdBillingGet', 'organizationId', organizationId)
            const localVarPath = `/organizations/{organization_id}/billing`
                .replace(`{${"organization_id"}}`, encodeURIComponent(String(organizationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Role
         * @param {string} roleId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleRoleRoleIdGet: async (roleId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('getRoleRoleRoleIdGet', 'roleId', roleId)
            const localVarPath = `/role/{role_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Schema Changes
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemaChangesDatabaseServerIdSchemaChangesGet: async (serverId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverId' is not null or undefined
            assertParamExists('getSchemaChangesDatabaseServerIdSchemaChangesGet', 'serverId', serverId)
            const localVarPath = `/database/{server_id}/schema_changes`
                .replace(`{${"server_id"}}`, encodeURIComponent(String(serverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Server Config
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServerConfigServerServerIdConfigurationGet: async (serverId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverId' is not null or undefined
            assertParamExists('getServerConfigServerServerIdConfigurationGet', 'serverId', serverId)
            const localVarPath = `/server/{server_id}/configuration`
                .replace(`{${"server_id"}}`, encodeURIComponent(String(serverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Server
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServerServerServerIdGet: async (serverId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverId' is not null or undefined
            assertParamExists('getServerServerServerIdGet', 'serverId', serverId)
            const localVarPath = `/server/{server_id}`
                .replace(`{${"server_id"}}`, encodeURIComponent(String(serverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Synthetic User
         * @param {string} syntheticUserId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyntheticUserSyntheticUserSyntheticUserIdGet: async (syntheticUserId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syntheticUserId' is not null or undefined
            assertParamExists('getSyntheticUserSyntheticUserSyntheticUserIdGet', 'syntheticUserId', syntheticUserId)
            const localVarPath = `/synthetic_user/{synthetic_user_id}`
                .replace(`{${"synthetic_user_id"}}`, encodeURIComponent(String(syntheticUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get User
         * @param {string} userId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUserUserIdGet: async (userId: string, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('getUserUserUserIdGet', 'userId', userId)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Users
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUsersGet: async (jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Invite User
         * @param {EmailRequest} emailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUserEmailSendPost: async (emailRequest: EmailRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'emailRequest' is not null or undefined
            assertParamExists('inviteUserEmailSendPost', 'emailRequest', emailRequest)
            const localVarPath = `/email/send`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(emailRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Billing Plans
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillingPlansBillingPlansGet: async (jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/billing/plans`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Hosted Proxies
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHostedProxiesHostedProxiesGet: async (jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/hosted_proxies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Roles
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRolesRolesGet: async (jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/roles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Servers
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listServersServersGet: async (jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/servers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List Synthetic Users
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSyntheticUsersSyntheticUsersGet: async (jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/synthetic_users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * :return: a list of all tables for the organization
         * @summary List Tables
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTablesTablesGet: async (jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/tables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * :return: a filter by id
         * @summary Update Filter
         * @param {string} filterId 
         * @param {FilterRequest} filterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFilterFilterFilterIdPost: async (filterId: string, filterRequest: FilterRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'filterId' is not null or undefined
            assertParamExists('updateFilterFilterFilterIdPost', 'filterId', filterId)
            // verify required parameter 'filterRequest' is not null or undefined
            assertParamExists('updateFilterFilterFilterIdPost', 'filterRequest', filterRequest)
            const localVarPath = `/filter/{filter_id}`
                .replace(`{${"filter_id"}}`, encodeURIComponent(String(filterId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(filterRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Hosted Proxy
         * @param {string} hostedProxyId 
         * @param {UpdateHostedProxyRequest} updateHostedProxyRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHostedProxyHostedProxyHostedProxyIdPost: async (hostedProxyId: string, updateHostedProxyRequest: UpdateHostedProxyRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'hostedProxyId' is not null or undefined
            assertParamExists('updateHostedProxyHostedProxyHostedProxyIdPost', 'hostedProxyId', hostedProxyId)
            // verify required parameter 'updateHostedProxyRequest' is not null or undefined
            assertParamExists('updateHostedProxyHostedProxyHostedProxyIdPost', 'updateHostedProxyRequest', updateHostedProxyRequest)
            const localVarPath = `/hosted_proxy/{hosted_proxy_id}`
                .replace(`{${"hosted_proxy_id"}}`, encodeURIComponent(String(hostedProxyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHostedProxyRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Role
         * @param {string} roleId 
         * @param {RoleCreateRequest} roleCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleRoleRoleIdPut: async (roleId: string, roleCreateRequest: RoleCreateRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'roleId' is not null or undefined
            assertParamExists('updateRoleRoleRoleIdPut', 'roleId', roleId)
            // verify required parameter 'roleCreateRequest' is not null or undefined
            assertParamExists('updateRoleRoleRoleIdPut', 'roleCreateRequest', roleCreateRequest)
            const localVarPath = `/role/{role_id}`
                .replace(`{${"role_id"}}`, encodeURIComponent(String(roleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(roleCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Server
         * @param {string} serverId 
         * @param {ServerCreateRequest} serverCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateServerServerServerIdPut: async (serverId: string, serverCreateRequest: ServerCreateRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'serverId' is not null or undefined
            assertParamExists('updateServerServerServerIdPut', 'serverId', serverId)
            // verify required parameter 'serverCreateRequest' is not null or undefined
            assertParamExists('updateServerServerServerIdPut', 'serverCreateRequest', serverCreateRequest)
            const localVarPath = `/server/{server_id}`
                .replace(`{${"server_id"}}`, encodeURIComponent(String(serverId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(serverCreateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Synthetic User Password
         * @param {string} syntheticUserId 
         * @param {SyntheticUserUpdatePasswordRequest} syntheticUserUpdatePasswordRequest 
         * @param {any} [backgroundTasks] 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyntheticUserPasswordSyntheticUserSyntheticUserIdPasswordPost: async (syntheticUserId: string, syntheticUserUpdatePasswordRequest: SyntheticUserUpdatePasswordRequest, backgroundTasks?: any, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syntheticUserId' is not null or undefined
            assertParamExists('updateSyntheticUserPasswordSyntheticUserSyntheticUserIdPasswordPost', 'syntheticUserId', syntheticUserId)
            // verify required parameter 'syntheticUserUpdatePasswordRequest' is not null or undefined
            assertParamExists('updateSyntheticUserPasswordSyntheticUserSyntheticUserIdPasswordPost', 'syntheticUserUpdatePasswordRequest', syntheticUserUpdatePasswordRequest)
            const localVarPath = `/synthetic_user/{synthetic_user_id}/password`
                .replace(`{${"synthetic_user_id"}}`, encodeURIComponent(String(syntheticUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (backgroundTasks !== undefined) {
                for (const [key, value] of Object.entries(backgroundTasks)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syntheticUserUpdatePasswordRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update Synthetic User
         * @param {string} syntheticUserId 
         * @param {SyntheticUserUpdateRequest} syntheticUserUpdateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyntheticUserSyntheticUserSyntheticUserIdPut: async (syntheticUserId: string, syntheticUserUpdateRequest: SyntheticUserUpdateRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'syntheticUserId' is not null or undefined
            assertParamExists('updateSyntheticUserSyntheticUserSyntheticUserIdPut', 'syntheticUserId', syntheticUserId)
            // verify required parameter 'syntheticUserUpdateRequest' is not null or undefined
            assertParamExists('updateSyntheticUserSyntheticUserSyntheticUserIdPut', 'syntheticUserUpdateRequest', syntheticUserUpdateRequest)
            const localVarPath = `/synthetic_user/{synthetic_user_id}`
                .replace(`{${"synthetic_user_id"}}`, encodeURIComponent(String(syntheticUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(syntheticUserUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update User
         * @param {string} userId 
         * @param {UserRequest} userRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserUserUserIdPut: async (userId: string, userRequest: UserRequest, jwtToken?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('updateUserUserUserIdPut', 'userId', userId)
            // verify required parameter 'userRequest' is not null or undefined
            assertParamExists('updateUserUserUserIdPut', 'userRequest', userRequest)
            const localVarPath = `/user/{user_id}`
                .replace(`{${"user_id"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProtectedApi - functional programming interface
 * @export
 */
export const ProtectedApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProtectedApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Accept Toc
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async acceptTocAcceptTocPost(jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.acceptTocAcceptTocPost(jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.acceptTocAcceptTocPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change Owner
         * @param {string} userId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changeOwnerUserUserIdChangeOwnerPost(userId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changeOwnerUserUserIdChangeOwnerPost(userId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.changeOwnerUserUserIdChangeOwnerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Change Pan
         * @param {ChangePlanRequest} changePlanRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async changePanBillingPlanChangePost(changePlanRequest: ChangePlanRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.changePanBillingPlanChangePost(changePlanRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.changePanBillingPlanChangePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Api Key
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createApiKeyServerServerIdApiKeyPost(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApiKeyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createApiKeyServerServerIdApiKeyPost(serverId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.createApiKeyServerServerIdApiKeyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Filter
         * @param {FilterRequest} filterRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createFilterFilterPost(filterRequest: FilterRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createFilterFilterPost(filterRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.createFilterFilterPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Hosted Proxy
         * @param {CreateHostedProxyRequest} createHostedProxyRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createHostedProxyHostedProxyPost(createHostedProxyRequest: CreateHostedProxyRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HostedProxyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createHostedProxyHostedProxyPost(createHostedProxyRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.createHostedProxyHostedProxyPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Org
         * @param {OrganizationRequest} organizationRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createOrgOrganizationsPost(organizationRequest: OrganizationRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createOrgOrganizationsPost(organizationRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.createOrgOrganizationsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Role
         * @param {RoleCreateRequest} roleCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createRoleRolePost(roleCreateRequest: RoleCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createRoleRolePost(roleCreateRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.createRoleRolePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Server
         * @param {ServerCreateRequest} serverCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createServerServerPost(serverCreateRequest: ServerCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createServerServerPost(serverCreateRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.createServerServerPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Synthetic User
         * @param {SyntheticUserCreateRequest} syntheticUserCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createSyntheticUserSyntheticUserPost(syntheticUserCreateRequest: SyntheticUserCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyntheticUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createSyntheticUserSyntheticUserPost(syntheticUserCreateRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.createSyntheticUserSyntheticUserPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create User
         * @param {UserRequest} userRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUserUsersPost(userRequest: UserRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUserUsersPost(userRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.createUserUsersPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Api Key
         * @param {string} serverId 
         * @param {string} apiKeyId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteApiKeyServerServerIdApiKeyApiKeyIdDelete(serverId: string, apiKeyId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteApiKeyServerServerIdApiKeyApiKeyIdDelete(serverId, apiKeyId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.deleteApiKeyServerServerIdApiKeyApiKeyIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Filter
         * @param {string} filterId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteFilterFilterFilterIdDelete(filterId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteFilterFilterFilterIdDelete(filterId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.deleteFilterFilterFilterIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Hosted Proxy
         * @param {string} hostedProxyId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteHostedProxyHostedProxyHostedProxyIdDelete(hostedProxyId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteHostedProxyHostedProxyHostedProxyIdDelete(hostedProxyId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.deleteHostedProxyHostedProxyHostedProxyIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Org
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteOrgOrganizationDelete(jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteOrgOrganizationDelete(jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.deleteOrgOrganizationDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Role
         * @param {string} roleId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteRoleRoleRoleIdDelete(roleId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteRoleRoleRoleIdDelete(roleId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.deleteRoleRoleRoleIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Server
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteServerServerServerIdDelete(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteServerServerServerIdDelete(serverId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.deleteServerServerServerIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete Synthetic User
         * @param {string} syntheticUserId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteSyntheticUserSyntheticUserSyntheticUserIdDelete(syntheticUserId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteSyntheticUserSyntheticUserSyntheticUserIdDelete(syntheticUserId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.deleteSyntheticUserSyntheticUserSyntheticUserIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete User
         * @param {string} userId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUserUserUserIdDelete(userId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUserUserUserIdDelete(userId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.deleteUserUserUserIdDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * :return: a filter by id
         * @summary Get Filter
         * @param {string} filterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFilterFilterFilterIdGet(filterId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFilterFilterFilterIdGet(filterId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getFilterFilterFilterIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * :return: a list of all filters for the organization
         * @summary Get Filters
         * @param {boolean} [archived] 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFiltersFiltersGet(archived?: boolean, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<FilterResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFiltersFiltersGet(archived, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getFiltersFiltersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Hosted Proxy
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHostedProxyHostedProxyServerIdGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HostedProxyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHostedProxyHostedProxyServerIdGet(serverId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getHostedProxyHostedProxyServerIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Org
         * @param {string} organizationId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrgOrganizationsOrganizationIdGet(organizationId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrgOrganizationsOrganizationIdGet(organizationId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getOrgOrganizationsOrganizationIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Organization Billing
         * @param {string} organizationId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getOrganizationBillingOrganizationsOrganizationIdBillingGet(organizationId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SubscriptionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getOrganizationBillingOrganizationsOrganizationIdBillingGet(organizationId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getOrganizationBillingOrganizationsOrganizationIdBillingGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Role
         * @param {string} roleId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRoleRoleRoleIdGet(roleId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRoleRoleRoleIdGet(roleId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getRoleRoleRoleIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Schema Changes
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSchemaChangesDatabaseServerIdSchemaChangesGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSchemaChangesDatabaseServerIdSchemaChangesGet(serverId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getSchemaChangesDatabaseServerIdSchemaChangesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Server Config
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServerConfigServerServerIdConfigurationGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProxyConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServerConfigServerServerIdConfigurationGet(serverId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getServerConfigServerServerIdConfigurationGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Server
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getServerServerServerIdGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getServerServerServerIdGet(serverId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getServerServerServerIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Synthetic User
         * @param {string} syntheticUserId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSyntheticUserSyntheticUserSyntheticUserIdGet(syntheticUserId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyntheticUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSyntheticUserSyntheticUserSyntheticUserIdGet(syntheticUserId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getSyntheticUserSyntheticUserSyntheticUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get User
         * @param {string} userId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserUserUserIdGet(userId: string, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserUserUserIdGet(userId, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getUserUserUserIdGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Users
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersUsersGet(jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersUsersGet(jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.getUsersUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Invite User
         * @param {EmailRequest} emailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inviteUserEmailSendPost(emailRequest: EmailRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inviteUserEmailSendPost(emailRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.inviteUserEmailSendPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Billing Plans
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listBillingPlansBillingPlansGet(jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<{ [key: string]: any; }>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listBillingPlansBillingPlansGet(jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.listBillingPlansBillingPlansGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Hosted Proxies
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listHostedProxiesHostedProxiesGet(jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<HostedProxyResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listHostedProxiesHostedProxiesGet(jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.listHostedProxiesHostedProxiesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Roles
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listRolesRolesGet(jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<RoleResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listRolesRolesGet(jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.listRolesRolesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Servers
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listServersServersGet(jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<ServerResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listServersServersGet(jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.listServersServersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List Synthetic Users
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listSyntheticUsersSyntheticUsersGet(jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SyntheticUserResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listSyntheticUsersSyntheticUsersGet(jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.listSyntheticUsersSyntheticUsersGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * :return: a list of all tables for the organization
         * @summary List Tables
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listTablesTablesGet(jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TableResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listTablesTablesGet(jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.listTablesTablesGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * :return: a filter by id
         * @summary Update Filter
         * @param {string} filterId 
         * @param {FilterRequest} filterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateFilterFilterFilterIdPost(filterId: string, filterRequest: FilterRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateFilterFilterFilterIdPost(filterId, filterRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.updateFilterFilterFilterIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Hosted Proxy
         * @param {string} hostedProxyId 
         * @param {UpdateHostedProxyRequest} updateHostedProxyRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateHostedProxyHostedProxyHostedProxyIdPost(hostedProxyId: string, updateHostedProxyRequest: UpdateHostedProxyRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HostedProxyResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateHostedProxyHostedProxyHostedProxyIdPost(hostedProxyId, updateHostedProxyRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.updateHostedProxyHostedProxyHostedProxyIdPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Role
         * @param {string} roleId 
         * @param {RoleCreateRequest} roleCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateRoleRoleRoleIdPut(roleId: string, roleCreateRequest: RoleCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<RoleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateRoleRoleRoleIdPut(roleId, roleCreateRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.updateRoleRoleRoleIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Server
         * @param {string} serverId 
         * @param {ServerCreateRequest} serverCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateServerServerServerIdPut(serverId: string, serverCreateRequest: ServerCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ServerResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateServerServerServerIdPut(serverId, serverCreateRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.updateServerServerServerIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Synthetic User Password
         * @param {string} syntheticUserId 
         * @param {SyntheticUserUpdatePasswordRequest} syntheticUserUpdatePasswordRequest 
         * @param {any} [backgroundTasks] 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSyntheticUserPasswordSyntheticUserSyntheticUserIdPasswordPost(syntheticUserId: string, syntheticUserUpdatePasswordRequest: SyntheticUserUpdatePasswordRequest, backgroundTasks?: any, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyntheticUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSyntheticUserPasswordSyntheticUserSyntheticUserIdPasswordPost(syntheticUserId, syntheticUserUpdatePasswordRequest, backgroundTasks, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.updateSyntheticUserPasswordSyntheticUserSyntheticUserIdPasswordPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update Synthetic User
         * @param {string} syntheticUserId 
         * @param {SyntheticUserUpdateRequest} syntheticUserUpdateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateSyntheticUserSyntheticUserSyntheticUserIdPut(syntheticUserId: string, syntheticUserUpdateRequest: SyntheticUserUpdateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SyntheticUserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateSyntheticUserSyntheticUserSyntheticUserIdPut(syntheticUserId, syntheticUserUpdateRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.updateSyntheticUserSyntheticUserSyntheticUserIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update User
         * @param {string} userId 
         * @param {UserRequest} userRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateUserUserUserIdPut(userId: string, userRequest: UserRequest, jwtToken?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UserResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateUserUserUserIdPut(userId, userRequest, jwtToken, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProtectedApi.updateUserUserUserIdPut']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProtectedApi - factory interface
 * @export
 */
export const ProtectedApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProtectedApiFp(configuration)
    return {
        /**
         * 
         * @summary Accept Toc
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        acceptTocAcceptTocPost(jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.acceptTocAcceptTocPost(jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change Owner
         * @param {string} userId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changeOwnerUserUserIdChangeOwnerPost(userId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.changeOwnerUserUserIdChangeOwnerPost(userId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Change Pan
         * @param {ChangePlanRequest} changePlanRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        changePanBillingPlanChangePost(changePlanRequest: ChangePlanRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.changePanBillingPlanChangePost(changePlanRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Api Key
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createApiKeyServerServerIdApiKeyPost(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<ApiKeyResponse> {
            return localVarFp.createApiKeyServerServerIdApiKeyPost(serverId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Filter
         * @param {FilterRequest} filterRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createFilterFilterPost(filterRequest: FilterRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<FilterResponse> {
            return localVarFp.createFilterFilterPost(filterRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Hosted Proxy
         * @param {CreateHostedProxyRequest} createHostedProxyRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createHostedProxyHostedProxyPost(createHostedProxyRequest: CreateHostedProxyRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<HostedProxyResponse> {
            return localVarFp.createHostedProxyHostedProxyPost(createHostedProxyRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Org
         * @param {OrganizationRequest} organizationRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrgOrganizationsPost(organizationRequest: OrganizationRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponse> {
            return localVarFp.createOrgOrganizationsPost(organizationRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Role
         * @param {RoleCreateRequest} roleCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createRoleRolePost(roleCreateRequest: RoleCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoleResponse> {
            return localVarFp.createRoleRolePost(roleCreateRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Server
         * @param {ServerCreateRequest} serverCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createServerServerPost(serverCreateRequest: ServerCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<ServerResponse> {
            return localVarFp.createServerServerPost(serverCreateRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Synthetic User
         * @param {SyntheticUserCreateRequest} syntheticUserCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createSyntheticUserSyntheticUserPost(syntheticUserCreateRequest: SyntheticUserCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<SyntheticUserResponse> {
            return localVarFp.createSyntheticUserSyntheticUserPost(syntheticUserCreateRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create User
         * @param {UserRequest} userRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUserUsersPost(userRequest: UserRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.createUserUsersPost(userRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Api Key
         * @param {string} serverId 
         * @param {string} apiKeyId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteApiKeyServerServerIdApiKeyApiKeyIdDelete(serverId: string, apiKeyId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteApiKeyServerServerIdApiKeyApiKeyIdDelete(serverId, apiKeyId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Filter
         * @param {string} filterId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteFilterFilterFilterIdDelete(filterId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteFilterFilterFilterIdDelete(filterId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Hosted Proxy
         * @param {string} hostedProxyId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteHostedProxyHostedProxyHostedProxyIdDelete(hostedProxyId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteHostedProxyHostedProxyHostedProxyIdDelete(hostedProxyId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Org
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrgOrganizationDelete(jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteOrgOrganizationDelete(jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Role
         * @param {string} roleId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteRoleRoleRoleIdDelete(roleId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteRoleRoleRoleIdDelete(roleId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Server
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteServerServerServerIdDelete(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteServerServerServerIdDelete(serverId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete Synthetic User
         * @param {string} syntheticUserId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteSyntheticUserSyntheticUserSyntheticUserIdDelete(syntheticUserId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteSyntheticUserSyntheticUserSyntheticUserIdDelete(syntheticUserId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete User
         * @param {string} userId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUserUserUserIdDelete(userId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.deleteUserUserUserIdDelete(userId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * :return: a filter by id
         * @summary Get Filter
         * @param {string} filterId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFilterFilterFilterIdGet(filterId: string, options?: RawAxiosRequestConfig): AxiosPromise<FilterResponse> {
            return localVarFp.getFilterFilterFilterIdGet(filterId, options).then((request) => request(axios, basePath));
        },
        /**
         * :return: a list of all filters for the organization
         * @summary Get Filters
         * @param {boolean} [archived] 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFiltersFiltersGet(archived?: boolean, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<FilterResponse>> {
            return localVarFp.getFiltersFiltersGet(archived, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Hosted Proxy
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHostedProxyHostedProxyServerIdGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<HostedProxyResponse> {
            return localVarFp.getHostedProxyHostedProxyServerIdGet(serverId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Org
         * @param {string} organizationId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrgOrganizationsOrganizationIdGet(organizationId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<OrganizationResponse> {
            return localVarFp.getOrgOrganizationsOrganizationIdGet(organizationId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Organization Billing
         * @param {string} organizationId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getOrganizationBillingOrganizationsOrganizationIdBillingGet(organizationId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<SubscriptionResponse> {
            return localVarFp.getOrganizationBillingOrganizationsOrganizationIdBillingGet(organizationId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Role
         * @param {string} roleId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRoleRoleRoleIdGet(roleId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoleResponse> {
            return localVarFp.getRoleRoleRoleIdGet(roleId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Schema Changes
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSchemaChangesDatabaseServerIdSchemaChangesGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.getSchemaChangesDatabaseServerIdSchemaChangesGet(serverId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Server Config
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServerConfigServerServerIdConfigurationGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<ProxyConfigurationResponse> {
            return localVarFp.getServerConfigServerServerIdConfigurationGet(serverId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Server
         * @param {string} serverId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getServerServerServerIdGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<ServerResponse> {
            return localVarFp.getServerServerServerIdGet(serverId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Synthetic User
         * @param {string} syntheticUserId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSyntheticUserSyntheticUserSyntheticUserIdGet(syntheticUserId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<SyntheticUserResponse> {
            return localVarFp.getSyntheticUserSyntheticUserSyntheticUserIdGet(syntheticUserId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get User
         * @param {string} userId 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserUserUserIdGet(userId: string, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.getUserUserUserIdGet(userId, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Users
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersUsersGet(jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<UserResponse>> {
            return localVarFp.getUsersUsersGet(jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Invite User
         * @param {EmailRequest} emailRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inviteUserEmailSendPost(emailRequest: EmailRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.inviteUserEmailSendPost(emailRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Billing Plans
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listBillingPlansBillingPlansGet(jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<{ [key: string]: any; }>> {
            return localVarFp.listBillingPlansBillingPlansGet(jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Hosted Proxies
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listHostedProxiesHostedProxiesGet(jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<HostedProxyResponse>> {
            return localVarFp.listHostedProxiesHostedProxiesGet(jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Roles
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listRolesRolesGet(jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<RoleResponse>> {
            return localVarFp.listRolesRolesGet(jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Servers
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listServersServersGet(jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<ServerResponse>> {
            return localVarFp.listServersServersGet(jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List Synthetic Users
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listSyntheticUsersSyntheticUsersGet(jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<SyntheticUserResponse>> {
            return localVarFp.listSyntheticUsersSyntheticUsersGet(jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * :return: a list of all tables for the organization
         * @summary List Tables
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listTablesTablesGet(jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<TableResponse>> {
            return localVarFp.listTablesTablesGet(jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * :return: a filter by id
         * @summary Update Filter
         * @param {string} filterId 
         * @param {FilterRequest} filterRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateFilterFilterFilterIdPost(filterId: string, filterRequest: FilterRequest, options?: RawAxiosRequestConfig): AxiosPromise<FilterResponse> {
            return localVarFp.updateFilterFilterFilterIdPost(filterId, filterRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Hosted Proxy
         * @param {string} hostedProxyId 
         * @param {UpdateHostedProxyRequest} updateHostedProxyRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateHostedProxyHostedProxyHostedProxyIdPost(hostedProxyId: string, updateHostedProxyRequest: UpdateHostedProxyRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<HostedProxyResponse> {
            return localVarFp.updateHostedProxyHostedProxyHostedProxyIdPost(hostedProxyId, updateHostedProxyRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Role
         * @param {string} roleId 
         * @param {RoleCreateRequest} roleCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateRoleRoleRoleIdPut(roleId: string, roleCreateRequest: RoleCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<RoleResponse> {
            return localVarFp.updateRoleRoleRoleIdPut(roleId, roleCreateRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Server
         * @param {string} serverId 
         * @param {ServerCreateRequest} serverCreateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateServerServerServerIdPut(serverId: string, serverCreateRequest: ServerCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<ServerResponse> {
            return localVarFp.updateServerServerServerIdPut(serverId, serverCreateRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Synthetic User Password
         * @param {string} syntheticUserId 
         * @param {SyntheticUserUpdatePasswordRequest} syntheticUserUpdatePasswordRequest 
         * @param {any} [backgroundTasks] 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyntheticUserPasswordSyntheticUserSyntheticUserIdPasswordPost(syntheticUserId: string, syntheticUserUpdatePasswordRequest: SyntheticUserUpdatePasswordRequest, backgroundTasks?: any, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<SyntheticUserResponse> {
            return localVarFp.updateSyntheticUserPasswordSyntheticUserSyntheticUserIdPasswordPost(syntheticUserId, syntheticUserUpdatePasswordRequest, backgroundTasks, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update Synthetic User
         * @param {string} syntheticUserId 
         * @param {SyntheticUserUpdateRequest} syntheticUserUpdateRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateSyntheticUserSyntheticUserSyntheticUserIdPut(syntheticUserId: string, syntheticUserUpdateRequest: SyntheticUserUpdateRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<SyntheticUserResponse> {
            return localVarFp.updateSyntheticUserSyntheticUserSyntheticUserIdPut(syntheticUserId, syntheticUserUpdateRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update User
         * @param {string} userId 
         * @param {UserRequest} userRequest 
         * @param {string} [jwtToken] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateUserUserUserIdPut(userId: string, userRequest: UserRequest, jwtToken?: string, options?: RawAxiosRequestConfig): AxiosPromise<UserResponse> {
            return localVarFp.updateUserUserUserIdPut(userId, userRequest, jwtToken, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProtectedApi - object-oriented interface
 * @export
 * @class ProtectedApi
 * @extends {BaseAPI}
 */
export class ProtectedApi extends BaseAPI {
    /**
     * 
     * @summary Accept Toc
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public acceptTocAcceptTocPost(jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).acceptTocAcceptTocPost(jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change Owner
     * @param {string} userId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public changeOwnerUserUserIdChangeOwnerPost(userId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).changeOwnerUserUserIdChangeOwnerPost(userId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Change Pan
     * @param {ChangePlanRequest} changePlanRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public changePanBillingPlanChangePost(changePlanRequest: ChangePlanRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).changePanBillingPlanChangePost(changePlanRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Api Key
     * @param {string} serverId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public createApiKeyServerServerIdApiKeyPost(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).createApiKeyServerServerIdApiKeyPost(serverId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Filter
     * @param {FilterRequest} filterRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public createFilterFilterPost(filterRequest: FilterRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).createFilterFilterPost(filterRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Hosted Proxy
     * @param {CreateHostedProxyRequest} createHostedProxyRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public createHostedProxyHostedProxyPost(createHostedProxyRequest: CreateHostedProxyRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).createHostedProxyHostedProxyPost(createHostedProxyRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Org
     * @param {OrganizationRequest} organizationRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public createOrgOrganizationsPost(organizationRequest: OrganizationRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).createOrgOrganizationsPost(organizationRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Role
     * @param {RoleCreateRequest} roleCreateRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public createRoleRolePost(roleCreateRequest: RoleCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).createRoleRolePost(roleCreateRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Server
     * @param {ServerCreateRequest} serverCreateRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public createServerServerPost(serverCreateRequest: ServerCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).createServerServerPost(serverCreateRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Synthetic User
     * @param {SyntheticUserCreateRequest} syntheticUserCreateRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public createSyntheticUserSyntheticUserPost(syntheticUserCreateRequest: SyntheticUserCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).createSyntheticUserSyntheticUserPost(syntheticUserCreateRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create User
     * @param {UserRequest} userRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public createUserUsersPost(userRequest: UserRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).createUserUsersPost(userRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Api Key
     * @param {string} serverId 
     * @param {string} apiKeyId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public deleteApiKeyServerServerIdApiKeyApiKeyIdDelete(serverId: string, apiKeyId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).deleteApiKeyServerServerIdApiKeyApiKeyIdDelete(serverId, apiKeyId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Filter
     * @param {string} filterId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public deleteFilterFilterFilterIdDelete(filterId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).deleteFilterFilterFilterIdDelete(filterId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Hosted Proxy
     * @param {string} hostedProxyId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public deleteHostedProxyHostedProxyHostedProxyIdDelete(hostedProxyId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).deleteHostedProxyHostedProxyHostedProxyIdDelete(hostedProxyId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Org
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public deleteOrgOrganizationDelete(jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).deleteOrgOrganizationDelete(jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Role
     * @param {string} roleId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public deleteRoleRoleRoleIdDelete(roleId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).deleteRoleRoleRoleIdDelete(roleId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Server
     * @param {string} serverId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public deleteServerServerServerIdDelete(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).deleteServerServerServerIdDelete(serverId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete Synthetic User
     * @param {string} syntheticUserId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public deleteSyntheticUserSyntheticUserSyntheticUserIdDelete(syntheticUserId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).deleteSyntheticUserSyntheticUserSyntheticUserIdDelete(syntheticUserId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete User
     * @param {string} userId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public deleteUserUserUserIdDelete(userId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).deleteUserUserUserIdDelete(userId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * :return: a filter by id
     * @summary Get Filter
     * @param {string} filterId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getFilterFilterFilterIdGet(filterId: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getFilterFilterFilterIdGet(filterId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * :return: a list of all filters for the organization
     * @summary Get Filters
     * @param {boolean} [archived] 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getFiltersFiltersGet(archived?: boolean, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getFiltersFiltersGet(archived, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Hosted Proxy
     * @param {string} serverId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getHostedProxyHostedProxyServerIdGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getHostedProxyHostedProxyServerIdGet(serverId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Org
     * @param {string} organizationId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getOrgOrganizationsOrganizationIdGet(organizationId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getOrgOrganizationsOrganizationIdGet(organizationId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Organization Billing
     * @param {string} organizationId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getOrganizationBillingOrganizationsOrganizationIdBillingGet(organizationId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getOrganizationBillingOrganizationsOrganizationIdBillingGet(organizationId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Role
     * @param {string} roleId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getRoleRoleRoleIdGet(roleId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getRoleRoleRoleIdGet(roleId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Schema Changes
     * @param {string} serverId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getSchemaChangesDatabaseServerIdSchemaChangesGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getSchemaChangesDatabaseServerIdSchemaChangesGet(serverId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Server Config
     * @param {string} serverId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getServerConfigServerServerIdConfigurationGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getServerConfigServerServerIdConfigurationGet(serverId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Server
     * @param {string} serverId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getServerServerServerIdGet(serverId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getServerServerServerIdGet(serverId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Synthetic User
     * @param {string} syntheticUserId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getSyntheticUserSyntheticUserSyntheticUserIdGet(syntheticUserId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getSyntheticUserSyntheticUserSyntheticUserIdGet(syntheticUserId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get User
     * @param {string} userId 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getUserUserUserIdGet(userId: string, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getUserUserUserIdGet(userId, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Users
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public getUsersUsersGet(jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).getUsersUsersGet(jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Invite User
     * @param {EmailRequest} emailRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public inviteUserEmailSendPost(emailRequest: EmailRequest, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).inviteUserEmailSendPost(emailRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Billing Plans
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public listBillingPlansBillingPlansGet(jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).listBillingPlansBillingPlansGet(jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Hosted Proxies
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public listHostedProxiesHostedProxiesGet(jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).listHostedProxiesHostedProxiesGet(jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Roles
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public listRolesRolesGet(jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).listRolesRolesGet(jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Servers
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public listServersServersGet(jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).listServersServersGet(jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List Synthetic Users
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public listSyntheticUsersSyntheticUsersGet(jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).listSyntheticUsersSyntheticUsersGet(jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * :return: a list of all tables for the organization
     * @summary List Tables
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public listTablesTablesGet(jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).listTablesTablesGet(jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * :return: a filter by id
     * @summary Update Filter
     * @param {string} filterId 
     * @param {FilterRequest} filterRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public updateFilterFilterFilterIdPost(filterId: string, filterRequest: FilterRequest, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).updateFilterFilterFilterIdPost(filterId, filterRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Hosted Proxy
     * @param {string} hostedProxyId 
     * @param {UpdateHostedProxyRequest} updateHostedProxyRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public updateHostedProxyHostedProxyHostedProxyIdPost(hostedProxyId: string, updateHostedProxyRequest: UpdateHostedProxyRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).updateHostedProxyHostedProxyHostedProxyIdPost(hostedProxyId, updateHostedProxyRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Role
     * @param {string} roleId 
     * @param {RoleCreateRequest} roleCreateRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public updateRoleRoleRoleIdPut(roleId: string, roleCreateRequest: RoleCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).updateRoleRoleRoleIdPut(roleId, roleCreateRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Server
     * @param {string} serverId 
     * @param {ServerCreateRequest} serverCreateRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public updateServerServerServerIdPut(serverId: string, serverCreateRequest: ServerCreateRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).updateServerServerServerIdPut(serverId, serverCreateRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Synthetic User Password
     * @param {string} syntheticUserId 
     * @param {SyntheticUserUpdatePasswordRequest} syntheticUserUpdatePasswordRequest 
     * @param {any} [backgroundTasks] 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public updateSyntheticUserPasswordSyntheticUserSyntheticUserIdPasswordPost(syntheticUserId: string, syntheticUserUpdatePasswordRequest: SyntheticUserUpdatePasswordRequest, backgroundTasks?: any, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).updateSyntheticUserPasswordSyntheticUserSyntheticUserIdPasswordPost(syntheticUserId, syntheticUserUpdatePasswordRequest, backgroundTasks, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update Synthetic User
     * @param {string} syntheticUserId 
     * @param {SyntheticUserUpdateRequest} syntheticUserUpdateRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public updateSyntheticUserSyntheticUserSyntheticUserIdPut(syntheticUserId: string, syntheticUserUpdateRequest: SyntheticUserUpdateRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).updateSyntheticUserSyntheticUserSyntheticUserIdPut(syntheticUserId, syntheticUserUpdateRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update User
     * @param {string} userId 
     * @param {UserRequest} userRequest 
     * @param {string} [jwtToken] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProtectedApi
     */
    public updateUserUserUserIdPut(userId: string, userRequest: UserRequest, jwtToken?: string, options?: RawAxiosRequestConfig) {
        return ProtectedApiFp(this.configuration).updateUserUserUserIdPut(userId, userRequest, jwtToken, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProxyApi - axios parameter creator
 * @export
 */
export const ProxyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create Tables
         * @param {string} xProxyApiVersion 
         * @param {string} xProxyBuildDate 
         * @param {Array<TableResponse>} tableResponse 
         * @param {any} [backgroundTasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTablesTablesPost: async (xProxyApiVersion: string, xProxyBuildDate: string, tableResponse: Array<TableResponse>, backgroundTasks?: any, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xProxyApiVersion' is not null or undefined
            assertParamExists('createTablesTablesPost', 'xProxyApiVersion', xProxyApiVersion)
            // verify required parameter 'xProxyBuildDate' is not null or undefined
            assertParamExists('createTablesTablesPost', 'xProxyBuildDate', xProxyBuildDate)
            // verify required parameter 'tableResponse' is not null or undefined
            assertParamExists('createTablesTablesPost', 'tableResponse', tableResponse)
            const localVarPath = `/tables`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)

            if (backgroundTasks !== undefined) {
                for (const [key, value] of Object.entries(backgroundTasks)) {
                    localVarQueryParameter[key] = value;
                }
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xProxyApiVersion != null) {
                localVarHeaderParameter['x-proxy-api-version'] = String(xProxyApiVersion);
            }
            if (xProxyBuildDate != null) {
                localVarHeaderParameter['x-proxy-build-date'] = String(xProxyBuildDate);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(tableResponse, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create Usernames
         * @param {string} xProxyApiVersion 
         * @param {string} xProxyBuildDate 
         * @param {UsernamesRequest} usernamesRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createUsernamesUsernamesPost: async (xProxyApiVersion: string, xProxyBuildDate: string, usernamesRequest: UsernamesRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xProxyApiVersion' is not null or undefined
            assertParamExists('createUsernamesUsernamesPost', 'xProxyApiVersion', xProxyApiVersion)
            // verify required parameter 'xProxyBuildDate' is not null or undefined
            assertParamExists('createUsernamesUsernamesPost', 'xProxyBuildDate', xProxyBuildDate)
            // verify required parameter 'usernamesRequest' is not null or undefined
            assertParamExists('createUsernamesUsernamesPost', 'usernamesRequest', usernamesRequest)
            const localVarPath = `/usernames`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            if (xProxyApiVersion != null) {
                localVarHeaderParameter['x-proxy-api-version'] = String(xProxyApiVersion);
            }
            if (xProxyBuildDate != null) {
                localVarHeaderParameter['x-proxy-build-date'] = String(xProxyBuildDate);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(usernamesRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Configuration
         * @param {string} xProxyApiVersion 
         * @param {string} xProxyBuildDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationProxyConfigGet: async (xProxyApiVersion: string, xProxyBuildDate: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'xProxyApiVersion' is not null or undefined
            assertParamExists('getConfigurationProxyConfigGet', 'xProxyApiVersion', xProxyApiVersion)
            // verify required parameter 'xProxyBuildDate' is not null or undefined
            assertParamExists('getConfigurationProxyConfigGet', 'xProxyBuildDate', xProxyBuildDate)
            const localVarPath = `/proxy/config`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            if (xProxyApiVersion != null) {
                localVarHeaderParameter['x-proxy-api-version'] = String(xProxyApiVersion);
            }
            if (xProxyBuildDate != null) {
                localVarHeaderParameter['x-proxy-build-date'] = String(xProxyBuildDate);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get Last Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastUpdatedProxyConfigLastUpdatedGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/proxy/config/last_updated`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle proxy events from the server.
         * @summary Proxy Event
         * @param {ProxyEventRequest} proxyEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyEventProxyEventPost: async (proxyEventRequest: ProxyEventRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proxyEventRequest' is not null or undefined
            assertParamExists('proxyEventProxyEventPost', 'proxyEventRequest', proxyEventRequest)
            const localVarPath = `/proxy/event`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proxyEventRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Handle batch proxy events from the server.
         * @summary Proxy Events
         * @param {ProxyEventsBatchRequest} proxyEventsBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyEventsProxyEventsPost: async (proxyEventsBatchRequest: ProxyEventsBatchRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'proxyEventsBatchRequest' is not null or undefined
            assertParamExists('proxyEventsProxyEventsPost', 'proxyEventsBatchRequest', proxyEventsBatchRequest)
            const localVarPath = `/proxy/events`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication APIKeyHeader required
            await setApiKeyToObject(localVarHeaderParameter, "X-API-Key", configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(proxyEventsBatchRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProxyApi - functional programming interface
 * @export
 */
export const ProxyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProxyApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create Tables
         * @param {string} xProxyApiVersion 
         * @param {string} xProxyBuildDate 
         * @param {Array<TableResponse>} tableResponse 
         * @param {any} [backgroundTasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createTablesTablesPost(xProxyApiVersion: string, xProxyBuildDate: string, tableResponse: Array<TableResponse>, backgroundTasks?: any, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<TableResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createTablesTablesPost(xProxyApiVersion, xProxyBuildDate, tableResponse, backgroundTasks, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProxyApi.createTablesTablesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create Usernames
         * @param {string} xProxyApiVersion 
         * @param {string} xProxyBuildDate 
         * @param {UsernamesRequest} usernamesRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async createUsernamesUsernamesPost(xProxyApiVersion: string, xProxyBuildDate: string, usernamesRequest: UsernamesRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUsernamesUsernamesPost(xProxyApiVersion, xProxyBuildDate, usernamesRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProxyApi.createUsernamesUsernamesPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Configuration
         * @param {string} xProxyApiVersion 
         * @param {string} xProxyBuildDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getConfigurationProxyConfigGet(xProxyApiVersion: string, xProxyBuildDate: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProxyConfigurationResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getConfigurationProxyConfigGet(xProxyApiVersion, xProxyBuildDate, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProxyApi.getConfigurationProxyConfigGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get Last Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLastUpdatedProxyConfigLastUpdatedGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProxyConfigurationLastUpdatedAtResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLastUpdatedProxyConfigLastUpdatedGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProxyApi.getLastUpdatedProxyConfigLastUpdatedGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle proxy events from the server.
         * @summary Proxy Event
         * @param {ProxyEventRequest} proxyEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proxyEventProxyEventPost(proxyEventRequest: ProxyEventRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proxyEventProxyEventPost(proxyEventRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProxyApi.proxyEventProxyEventPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Handle batch proxy events from the server.
         * @summary Proxy Events
         * @param {ProxyEventsBatchRequest} proxyEventsBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async proxyEventsProxyEventsPost(proxyEventsBatchRequest: ProxyEventsBatchRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.proxyEventsProxyEventsPost(proxyEventsBatchRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProxyApi.proxyEventsProxyEventsPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProxyApi - factory interface
 * @export
 */
export const ProxyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProxyApiFp(configuration)
    return {
        /**
         * 
         * @summary Create Tables
         * @param {string} xProxyApiVersion 
         * @param {string} xProxyBuildDate 
         * @param {Array<TableResponse>} tableResponse 
         * @param {any} [backgroundTasks] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createTablesTablesPost(xProxyApiVersion: string, xProxyBuildDate: string, tableResponse: Array<TableResponse>, backgroundTasks?: any, options?: RawAxiosRequestConfig): AxiosPromise<Array<TableResponse>> {
            return localVarFp.createTablesTablesPost(xProxyApiVersion, xProxyBuildDate, tableResponse, backgroundTasks, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create Usernames
         * @param {string} xProxyApiVersion 
         * @param {string} xProxyBuildDate 
         * @param {UsernamesRequest} usernamesRequest 
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        createUsernamesUsernamesPost(xProxyApiVersion: string, xProxyBuildDate: string, usernamesRequest: UsernamesRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.createUsernamesUsernamesPost(xProxyApiVersion, xProxyBuildDate, usernamesRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Configuration
         * @param {string} xProxyApiVersion 
         * @param {string} xProxyBuildDate 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getConfigurationProxyConfigGet(xProxyApiVersion: string, xProxyBuildDate: string, options?: RawAxiosRequestConfig): AxiosPromise<ProxyConfigurationResponse> {
            return localVarFp.getConfigurationProxyConfigGet(xProxyApiVersion, xProxyBuildDate, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get Last Updated
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLastUpdatedProxyConfigLastUpdatedGet(options?: RawAxiosRequestConfig): AxiosPromise<ProxyConfigurationLastUpdatedAtResponse> {
            return localVarFp.getLastUpdatedProxyConfigLastUpdatedGet(options).then((request) => request(axios, basePath));
        },
        /**
         * Handle proxy events from the server.
         * @summary Proxy Event
         * @param {ProxyEventRequest} proxyEventRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyEventProxyEventPost(proxyEventRequest: ProxyEventRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.proxyEventProxyEventPost(proxyEventRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Handle batch proxy events from the server.
         * @summary Proxy Events
         * @param {ProxyEventsBatchRequest} proxyEventsBatchRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        proxyEventsProxyEventsPost(proxyEventsBatchRequest: ProxyEventsBatchRequest, options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.proxyEventsProxyEventsPost(proxyEventsBatchRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProxyApi - object-oriented interface
 * @export
 * @class ProxyApi
 * @extends {BaseAPI}
 */
export class ProxyApi extends BaseAPI {
    /**
     * 
     * @summary Create Tables
     * @param {string} xProxyApiVersion 
     * @param {string} xProxyBuildDate 
     * @param {Array<TableResponse>} tableResponse 
     * @param {any} [backgroundTasks] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProxyApi
     */
    public createTablesTablesPost(xProxyApiVersion: string, xProxyBuildDate: string, tableResponse: Array<TableResponse>, backgroundTasks?: any, options?: RawAxiosRequestConfig) {
        return ProxyApiFp(this.configuration).createTablesTablesPost(xProxyApiVersion, xProxyBuildDate, tableResponse, backgroundTasks, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create Usernames
     * @param {string} xProxyApiVersion 
     * @param {string} xProxyBuildDate 
     * @param {UsernamesRequest} usernamesRequest 
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof ProxyApi
     */
    public createUsernamesUsernamesPost(xProxyApiVersion: string, xProxyBuildDate: string, usernamesRequest: UsernamesRequest, options?: RawAxiosRequestConfig) {
        return ProxyApiFp(this.configuration).createUsernamesUsernamesPost(xProxyApiVersion, xProxyBuildDate, usernamesRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Configuration
     * @param {string} xProxyApiVersion 
     * @param {string} xProxyBuildDate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProxyApi
     */
    public getConfigurationProxyConfigGet(xProxyApiVersion: string, xProxyBuildDate: string, options?: RawAxiosRequestConfig) {
        return ProxyApiFp(this.configuration).getConfigurationProxyConfigGet(xProxyApiVersion, xProxyBuildDate, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get Last Updated
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProxyApi
     */
    public getLastUpdatedProxyConfigLastUpdatedGet(options?: RawAxiosRequestConfig) {
        return ProxyApiFp(this.configuration).getLastUpdatedProxyConfigLastUpdatedGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle proxy events from the server.
     * @summary Proxy Event
     * @param {ProxyEventRequest} proxyEventRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProxyApi
     */
    public proxyEventProxyEventPost(proxyEventRequest: ProxyEventRequest, options?: RawAxiosRequestConfig) {
        return ProxyApiFp(this.configuration).proxyEventProxyEventPost(proxyEventRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Handle batch proxy events from the server.
     * @summary Proxy Events
     * @param {ProxyEventsBatchRequest} proxyEventsBatchRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProxyApi
     */
    public proxyEventsProxyEventsPost(proxyEventsBatchRequest: ProxyEventsBatchRequest, options?: RawAxiosRequestConfig) {
        return ProxyApiFp(this.configuration).proxyEventsProxyEventsPost(proxyEventsBatchRequest, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PublicApi - axios parameter creator
 * @export
 */
export const PublicApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get Latest Published Image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPublishedImageProxyLatestPublishedImageGet: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/proxy/latest_published_image`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginLoginPost: async (loginRequest: LoginRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginRequest' is not null or undefined
            assertParamExists('loginLoginPost', 'loginRequest', loginRequest)
            const localVarPath = `/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Paddle Webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paddleWebhookWebhooksPaddlePost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/webhooks/paddle`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Verify Jwt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyJwtVerifyJwtPost: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/verify_jwt`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PublicApi - functional programming interface
 * @export
 */
export const PublicApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PublicApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get Latest Published Image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestPublishedImageProxyLatestPublishedImageGet(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DockerImage>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestPublishedImageProxyLatestPublishedImageGet(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.getLatestPublishedImageProxyLatestPublishedImageGet']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async loginLoginPost(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<{ [key: string]: any; }>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.loginLoginPost(loginRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.loginLoginPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Paddle Webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async paddleWebhookWebhooksPaddlePost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<any>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.paddleWebhookWebhooksPaddlePost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.paddleWebhookWebhooksPaddlePost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Verify Jwt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async verifyJwtVerifyJwtPost(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.verifyJwtVerifyJwtPost(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PublicApi.verifyJwtVerifyJwtPost']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PublicApi - factory interface
 * @export
 */
export const PublicApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PublicApiFp(configuration)
    return {
        /**
         * 
         * @summary Get Latest Published Image
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPublishedImageProxyLatestPublishedImageGet(options?: RawAxiosRequestConfig): AxiosPromise<DockerImage> {
            return localVarFp.getLatestPublishedImageProxyLatestPublishedImageGet(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login
         * @param {LoginRequest} loginRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        loginLoginPost(loginRequest: LoginRequest, options?: RawAxiosRequestConfig): AxiosPromise<{ [key: string]: any; }> {
            return localVarFp.loginLoginPost(loginRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Paddle Webhook
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        paddleWebhookWebhooksPaddlePost(options?: RawAxiosRequestConfig): AxiosPromise<any> {
            return localVarFp.paddleWebhookWebhooksPaddlePost(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Verify Jwt
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        verifyJwtVerifyJwtPost(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.verifyJwtVerifyJwtPost(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PublicApi - object-oriented interface
 * @export
 * @class PublicApi
 * @extends {BaseAPI}
 */
export class PublicApi extends BaseAPI {
    /**
     * 
     * @summary Get Latest Published Image
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public getLatestPublishedImageProxyLatestPublishedImageGet(options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).getLatestPublishedImageProxyLatestPublishedImageGet(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login
     * @param {LoginRequest} loginRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public loginLoginPost(loginRequest: LoginRequest, options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).loginLoginPost(loginRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Paddle Webhook
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public paddleWebhookWebhooksPaddlePost(options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).paddleWebhookWebhooksPaddlePost(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Verify Jwt
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PublicApi
     */
    public verifyJwtVerifyJwtPost(options?: RawAxiosRequestConfig) {
        return PublicApiFp(this.configuration).verifyJwtVerifyJwtPost(options).then((request) => request(this.axios, this.basePath));
    }
}



